import { render, staticRenderFns } from "./EmployeeWizardPfandGfOnly.vue?vue&type=template&id=d67f956a"
import script from "./EmployeeWizardPfandGfOnly.vue?vue&type=script&lang=js"
export * from "./EmployeeWizardPfandGfOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports